import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Home, Shield, Lightbulb } from 'lucide-react';
import './Mission.css';

const Mission = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  const manifesto = [
    {
      number: '01',
      title: 'Room-based housing',
      description: 'Affordable, safe, and private living spaces designed for your journey to independence.',
      icon: Home
    },
    {
      number: '02',
      title: 'Structured support',
      description: 'Clear guidelines and accountability measures that foster personal growth and responsibility.',
      icon: Shield
    },
    {
      number: '03',
      title: 'Local resources',
      description: 'Direct connections to employment, counseling, veteran services, and community programs.',
      icon: Lightbulb
    }
  ];

  return (
    <section id="mission" className="mission" ref={ref}>
      <div className="mission-container">
        <motion.div
          className="mission-header"
          initial={{ opacity: 0, y: 50 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <span className="section-label">Our Mission</span>
          <h2 className="section-title">
            Structure, accountability,
            <br />
            <span className="highlight">and a path forward.</span>
          </h2>
          <p className="section-description">
            Our mission is to provide a supportive living environment that empowers
            individuals to rebuild their lives, develop independence, and achieve
            stability through structure, accountability, and access to resources.
          </p>
        </motion.div>

        <div className="manifesto-grid">
          {manifesto.map((item, index) => {
            const Icon = item.icon;
            return (
              <motion.div
                key={index}
                className="manifesto-card"
                initial={{ opacity: 0, y: 50 }}
                animate={isInView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.8, delay: 0.2 + index * 0.15 }}
                whileHover={{ y: -10 }}
              >
                <div className="manifesto-icon">
                  <Icon size={32} />
                </div>
                <h3 className="manifesto-title">{item.title}</h3>
                <p className="manifesto-description">{item.description}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Mission;
